<template>
    <div class="engage_page" style="background: #f8f8f8;">
        <img v-if="listStatus" style="width:100%;" src="../assets/huishengzhaopin.jpg"/>
        <!-- <div v-if="listStatus" style="padding-bottom:100px;background:#f8f8f8;">
            <div class="solve head-label just_center" style="padding-top: 70px;">
                <img style="width:34px;" src="../assets/sangang1.png" >
                <div style="text-align: center;margin-left:20px;margin-right:20px;font-size:32px;font-weight:600;" class="font_size_24">
                    招聘职位
                </div>
                <img style="width:34px;" src="../assets/sangang2.png" >
            </div>
            <div class="just_center" style="width: 50%;margin: 0 auto;padding-top:30px;">
                <div style="margin: 0 auto;margin-top:20px;width: 176px;height:50px;border-radius:25px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                    <div @click="campusRecruitment(1)" style="font-size:16px;font-weight:600;text-align:center;cursor:pointer;border-radius:21px;background:#3fa8c7;color:#ffffff;width:160px;height:42px;line-height:42px;">社会招聘
                    </div>
                </div>
                <div style="margin: 0 auto;margin-top:20px;width: 176px;height:50px;border-radius:25px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                    <div @click="campusRecruitment(3)" style="font-size:16px;font-weight:600;text-align:center;border-radius:21px;cursor:pointer;background:#ffffff;border:1px solid #3fa8c7;color:#3fa8c7;width:160px;height:42px;line-height:42px;">校园招聘
                    </div>
                </div>
                <div style="margin: 0 auto;margin-top:20px;width: 176px;height:50px;border-radius:25px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                    <div @click="campusRecruitment(2)" style="font-size:16px;font-weight:600;text-align:center;border-radius:21px;background:#ffffff;cursor:pointer;border:1px solid #3fa8c7;color:#3fa8c7;width:160px;height:42px;line-height:42px;">实习招聘
                    </div>
                </div>
            </div>
        </div> -->
        <div v-if="listStatus" style="background:#ffffff;">
            <div class="solve head-label just_center" style="padding-top: 70px;">
                <img style="width:34px;" src="../assets/sangang1.png" >
                <div style="text-align: center;margin-left:20px;margin-right:20px;font-size:32px;font-weight:600;" class="font_size_24">
                    联系我们
                </div>
                <img style="width:34px;" src="../assets/sangang2.png" >
            </div>
        </div>

        <div v-if="listStatus" style="padding-top: 70px;display:flex;padding-bottom:70px;display:flex;background:#ffffff;">
            <div style="width:49%;text-align:right;">
                <div style="width:80%;margin-left:19%;position:relative;">
                    <img style="width:100%;z-index:100;" @mouseenter="onEnterNJ" @mouseleave="onLeaveNJ" :src="nanjing ? njSrc0 : njSrc" >
                    <div style="width:100%;z-index:0;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);" @mouseenter="onEnterNJ" @mouseleave="onLeaveNJ">
                        <div v-if="!nanjing" style="font-size:48px;color:#ffffff;text-align:center;">
                            南京
                        </div>
                        <div v-if="nanjing" style="font-size:48px;color:#333333;font-weight:600;text-align:center;">
                            南京
                        </div>
                        <div v-if="!nanjing" style="width:60%;margin:0 auto;margin-left:25%;">
                            <div style="text-align:justify;margin-top:15px;font-size:22px;color:#ffffff;">
                                地址：南京市秦淮区户部街15号
                            </div>
                            <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                兴业大厦21楼
                            </div>
                            <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                电话：025-86828106
                            </div>
                            <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                邮箱：wisdom@highhope.com
                            </div>
                        </div>
                        <div v-if="nanjing" style="margin-top:15px;font-size:46px;color:#333333;font-weight:600;text-align:center;">
                            NANJING
                        </div>
                    </div>
                </div>
            </div>
            <div style="width:49%;text-align:left;margin-left:1%;">
                <div style="width:80%;margin-left:1%;position:relative;">
                    <img style="width:100%;z-index:100;" @mouseenter="onEnterSH" @mouseleave="onLeaveSH" :src="shanghai ? shSrc : shSrc0" >
                    <div @mouseenter="onEnterSH" @mouseleave="onLeaveSH" style="width:100%;z-index:0;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);">
                        <div v-if="shanghai" style="font-size:48px;color:#ffffff;font-weight:600;text-align:center;">
                            上海
                        </div>
                        <div v-if="!shanghai" style="font-size:48px;color:#333333;font-weight:600;text-align:center;">
                            上海
                        </div>
                        <div v-if="shanghai" style="width:60%;margin:0 auto;margin-left:25%;">
                            <div style="text-align:justify;margin-top:15px;font-size:22px;color:#ffffff;">
                                地址：上海市虹口区东大名路501号
                            </div>
                            <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                白玉兰广场3707室
                            </div>
                            <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                电话：025-86828106
                            </div>
                            <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                邮箱：wisdom@highhope.com
                            </div>
                        </div>
                        <div v-if="!shanghai" style="margin-top:15px;font-size:46px;color:#333333;font-weight:600;text-align:center;">
                            SHANGHAI
                        </div>
                    </div>
                </div>
            </div>
        </div>

       
        <div v-if="campusRecruitmentStatus" style="padding-bottom:20px;background:#f8f8f8;">
            <div class="solve head-label just_center" style="padding-top: 76px;">
                <img style="width:34px;" src="../assets/sangang1.png" >
                <div style="text-align: center;margin-left:20px;margin-right:20px;font-size:32px;font-weight:600;" class="font_size_24">
                    {{engageName}}
                </div>
                <img style="width:34px;" src="../assets/sangang2.png" >
            </div>
            <div style="text-align:center;margin-top:16px;font-size:20px;">
                简历投递邮箱：
                <span style="color: #3fa8c7;">wisdom@highhope.com</span>
            </div>
            <div style="margin-top:30px;text-align:center;display:flex;justify-content: center;">
                <el-input
                    style="width:600px;height:50px;"
                    placeholder="请输入职位关键字"
                    v-model="input"
                    clearable>
                    </el-input>
                <div @click="searchPosition" style="background:#3fa8c7;color:#ffffff;width:160px;font-size:20px;height:50px;line-height:50px;cursor:pointer;">搜索职位</div>
            </div>
        </div>
        <div v-if="campusRecruitmentStatus" style="width:80%;margin:0 auto;background: rgb(248, 248, 248);padding-bottom:60px;">
            <div v-for="(item, index) in positions" :key="item" @click="handleDeatil(item)" style="width:calc(50% - 10px);height:290px;margin-top:15px;float:left;background:#ffffff;padding:45px 30px;box-sizing: border-box;box-shadow:0px 12px 12px rgba(0, 0, 0, 0.05);" :style="{marginLeft:(index%2 === 1 ? '15px' : '0')}">
                <div style="display:flex;justify-content: space-between;">
                    <div style="font-size:26px;">
                        <!-- <span style="width:36px;height:36px;background:#ff7e46;color:#ffffff;display:inline-block;line-height: 36px;text-align: center;">
                            急
                        </span> -->
                        <span style="margin-left:10px;font-size:32px;">{{item.title}}</span>
                    </div>
                    <div style="height:46px;line-height:46px;">
                        <img style="width:42px;cursor:pointer;height:42px;" src="../assets/youjiantou.png" >
                    </div>
                </div>
                <!-- <div style="font-size:16px;margin-top:31px;line-height:30px;">
                    <span style="font-weight:600;">岗位职责：</span>
                    <div style="line-height: 18px;line-height:26px;">{{item.content[0].name}}</div>
                </div> -->
            </div>
            <div style="clear:both;"></div>
        </div>
        <div v-if="detailStatus" style="width:66%;margin:0 auto;padding-top: 50px;padding-bottom:80px;">
            <div>
                <div style="font-size:26px;">
                    <!-- <span style="width:36px;height:36px;background:#ff7e46;color:#ffffff;display:inline-block;line-height: 36px;text-align: center;">
                        急
                    </span> -->
                    <span style="margin-left:10px;font-size:32px;">{{currentDetail.title}}</span>
                </div>
            </div>
            <div style="color:#3fa8c7;font-size: 16px;margin-top:12px;">
                 <!-- 发布于：2023年8月10日     -->
                 发布于：2024年9月13日 
            </div>
            <div style="display: flex;margin-top:20px;">
                <div style="width:65%;font-size:15px;padding-top:30px;line-height:26px;border-top:1px solid rgba(124, 225, 255, 0.6);">
                    <div>岗位职责：</div>
                    <div v-for="k in currentDetail.content" :key="k.name">{{k.name}}</div>

                    <div style="margin-top:30px;">任职要求：</div>
                    <div v-for="k in currentDetail.expects" :key="k.name">{{k.name}}</div>

                </div>
                <div style="width:30%;margin-left:5%;padding:20px;background:#ffffff;">
                    <div style="font-weight:700;font-size:24px;">最新职位</div>
                    <div style="margin-top:40px;padding-bottom:25px;border-bottom: 1px solid #e8eaed;">
                        <div style="font-size:20px;">
                            <!-- <span style="width:36px;height:36px;background:#ff7e46;color:#ffffff;display:inline-block;line-height: 36px;text-align: center;">
                                急
                            </span> -->
                            <!-- <span style="margin-left:10px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">{{currentType === 1 ? '市场中高级经理' : currentType === 2 ? '量化开发助理' : '市场助理（南京）'}}</span> -->
                            <span style="margin-left:10px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">{{currentType === 1 ? '市场高级经理（南京/上海）' : currentType === 2 ? '数据开发实习生' : '市场助理岗位（南京/上海）'}}</span>
                        </div>
                    </div>
                    <div style="margin-top:25px;padding-bottom:25px;border-bottom: 1px solid #e8eaed;">
                        <div style="font-size:20px;">
                            <!-- <span style="width:36px;height:36px;background:#ff7e46;color:#ffffff;display:inline-block;line-height: 36px;text-align: center;">
                                急
                            </span> -->
                            <!-- <span style="margin-left:10px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">{{currentType === 1 ? '助理市场经理' : currentType === 2 ? '量化研究助理' : '市场助理（上海）'}}</span> -->
                            <span style="margin-left:10px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">{{currentType === 1 ? '量化投资基金经理（南京/上海）' : currentType === 2 ? '人力资源实习生' : '基金产品运营岗位（南京）'}}</span>
                        </div>
                    </div>
                    <div style="margin-top:25px;padding-bottom:25px;border-bottom: 1px solid #e8eaed;">
                        <div style="font-size:20px;">
                            <!-- <span style="width:36px;height:36px;background:#ff7e46;color:#ffffff;display:inline-block;line-height: 36px;text-align: center;">
                                急
                            </span> -->
                            <!-- <span style="margin-left:10px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">{{currentType === 1 ? '资产研究总监' : currentType === 2 ? '市场助理' : '产品运营助理'}}</span> -->
                            <span style="margin-left:10px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">{{currentType === 1 ? '产品运营经理（南京）' : currentType === 2 ? '量化研究助理' : '量化研究助理（实习/校招）'}}</span>
                        </div>
                    </div>
                    <!-- <div v-if="currentType !== 3" style="margin-top:25px;padding-bottom:25px;border-bottom: 1px solid #e8eaed;"> -->
                    <div v-if="currentType === 2" style="margin-top:25px;padding-bottom:25px;border-bottom: 1px solid #e8eaed;">
                        <div style="font-size:20px;">
                            <!-- <span style="width:36px;height:36px;background:#ff7e46;color:#ffffff;display:inline-block;line-height: 36px;text-align: center;">
                                急
                            </span> -->
                            <!-- <span style="margin-left:10px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">{{currentType === 1 ? '资产配置基金经理' : '风控合规助理'}}</span> -->
                            <span style="margin-left:10px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">{{'资产配置实习生'}}</span>
                        </div>
                    </div>
                    <div style="margin-top:20px;">
                        <div @click="goBack()" style="font-size:20px;color:#3fa8c7;cursor:pointer;">
                            <img style="width:20px;margin-right: 10px;vertical-align: middle;" src="../assets/fanhui.png" >返回上一页
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Index',
        data() {
            return {
              listStatus: true,
              nanjing: false,
              njSrc: require('../assets/nanjing.png'),
              njSrc0: require('../assets/nanjing0.png'),
              shanghai: false,
              shSrc: require('../assets/shanghai.png'),
              shSrc0: require('../assets/shanghai0.png'),
              campusRecruitmentStatus: false,
              currentType: 1,
              engageName: '社会招聘',
              input: '',
              currentDetail: {},
            //   positions: [{
            //     title: '市场中高级经理',
            //     content: [{
            //         name: '1、开发及维护金融机构渠道、企业客户或个人高净值客户，推广公司资产配置策略理念及各类产品线，有效扩大公司产品管理规模；'
            //     }, {
            //         name: '2、服务客户的投资需求，促成落单并完成公司制定的市场考核目标；'
            //     }, {
            //         name: '3、策划并执行产品推广、客户路演及品牌宣传活动。'
            //     }],
            //     expects: [{
            //         name: '1、经济类相关专业，大学本科及以上学历，具备基金从业资格；'
            //     }, {
            //         name: '2、对资管行业、资产配置策略、量化投资领域有较好的理解及知识储备；'
            //     }, {
            //         name: '3、银行、信托、券商、公募基金、私募基金等从事市场开拓或财富管理业务岗位，2年以上经验；'
            //     }, {
            //         name: '4、具备良好的沟通表达能力、协调能力及团队协作精神；'
            //     }, {
            //         name: '5、具备较好的客户和渠道资源，具备独立拓展市场的能力。'
            //     }]
            //   }, {
            //     title: '助理市场经理',
            //     content: [{
            //         name: '1、有效的贯彻执行公司市场拓展政策和流程；'
            //     }, {
            //         name: '2、协助市场经理进行业务拓展和客户关系维护；'
            //     }, {
            //         name: '3、负责制作公司各基金产品运作情况定期报告；'
            //     }, {
            //         name: '4、负责各类金融机构尽调文档的编制与汇总；'
            //     }, {
            //         name: '5、负责各类宣传材料的制作；'
            //     }, {
            //         name: '6、负责部门文档的建设与管理，为市场人员提供中台支持；'
            //     }, {
            //         name: '7、有效挖掘市场行业信息，并及时把相关信息汇总反馈给部门领导；'
            //     }, {
            //         name: '8、协助进行品牌推广。'
            //     }],
            //     expects: [{
            //         name: '1、国内外知名院校，金融、经济、工商管理等相关专业，硕士及以上学历；'
            //     }, {
            //         name: '2、对资管行业、资产配置、量化投资领域有一定了解与知识储备；'
            //     }, {
            //         name: '3、具有较强的ppt制作、数据处理方面的能力；'
            //     }, {
            //         name: '4、有较强的协调、沟通能力及人际交往能力，具备较强的计划和执行能力；'
            //     }, {
            //         name: '5、持有CFA、FRM证书优先；'
            //     }, {
            //         name: '6、良好的团队协作精神，做事细心负责、为人诚实可靠、品行端正。'
            //     }]
            //   }, {
            //     title: '资产研究总监/副总监',
            //     content: [{
            //         name: '1、带领资产研究团队负责量化方向的研究工作并协助自营基金组合的管理。研究内容包括但不限于：大类资产配置、基金组合分析、基金投资策略、基金产品分析；'
            //     }, {
            //         name: '2、负责定期和专题研究报告撰写、满足外部大型机构的研究需求；'
            //     }, {
            //         name: '3、跟踪A股市场变化，并形成A股策略报告及大类资产配置报告；'
            //     }, {
            //         name: '4、根据业务发展和部门需求、扩展研究覆盖范围、完成领导交办事务。'
            //     }],
            //     expects: [{
            //         name: '1、硕士及以上学历，量化，金融工程，计算机或经济金融相关专业；'
            //     }, {
            //         name: '2、系统掌握经济学分析方法论，具备较强的数据、政策解读能力；'
            //     }, {
            //         name: '3、熟悉大类资产配置方法，并逐渐已经形成自己的资产配置体系；'
            //     }, {
            //         name: '4、熟练掌握策略分析主要内容；'
            //     }, {
            //         name: '5、熟悉A股市场，具有一定投资经验；'
            //     }, {
            //         name: '6、熟悉财务分析方法；熟练使用Excel或Python进行数据分析并搭建财务模型、策略模型；'
            //     }]
            //   }, {
            //     title: '资产配置基金经理',
            //     content: [{
            //         name: '1、 负责设计新的配置型产品，管理指定的配置型产品，包括业绩和日常运营管理'
            //     }, {
            //         name: '2、负责进行核心资产的管理，进一步完善资产配置研究体系'
            //     }, {
            //         name: '3、负责挖掘优质私募管理人，开发投顾策略和管理跟踪体系，投后与底层投顾日常沟通、跟踪'
            //     }, {
            //         name: '4、负责对外提供资产配置建议和咨询'
            //     }, {
            //         name: '5、负责对外研究的输出和路演'
            //     }],
            //     expects: [{
            //         name: '1、5年以上的投资工作经验'
            //     }, {
            //         name: '2、具有丰富的大类资产或策略研究经验，有实盘管理FOF的经验和业绩'
            //     }, {
            //         name: '3、具备3+3投顾资质要求的连续三年投资业绩'
            //     }, {
            //         name: '4、在泛上海区域具有一定的投资资源，包括投顾、券商和资金端'
            //     }, {
            //         name: '5、具有海外投资管理经历优先'
            //     }, {
            //         name: '6、有过团队管理经验者优先'
            //     }]
            //   }, {
            //     title: '资产配置研究员',
            //     content: [{
            //         name: '1、 协助基金经理构建和维护资产配置组合，参与组合绩效归因模型的开发和完善，并提供组合投资的配置和风控建议，定期生成产品运作报告；'
            //     }, {
            //         name: '2、 构建各量化策略的市场监控模型，研究各类子基金的量化投资策略，定期撰写资产配置月刊等品牌宣传材料；'
            //     }, {
            //         name: '3、 维护子基金业绩评价和筛选体系，定期与投顾进行尽调访谈并撰写分析报告；'
            //     }, {
            //         name: '4、 协助完成基金评价中心规划材料，推进基金评价项目，安排、处理基金评价中心日常事务；'
            //     }, {
            //         name: '5、 协助参与投顾调研，以及核心投顾池、备选基金池的组建和维护；'
            //     }, {
            //         name: '6、 数据系统维护以及领导交办的其他工作。'
            //     }],
            //     expects: [{
            //         name: '1、国内外知名院校，金融工程、数学等相关专业，硕士及以上学历；'
            //     }, {
            //         name: '2、3年以上相关工作经验；'
            //     }, {
            //         name: '3、掌握主流编程语言，Python、Excel VBA等，具有较强的数据分析和编程能力，掌握主流数据库，如MySQL/MS SQL/Oracle等；'
            //     }, {
            //         name: '4、了解国内金融市场及量化策略，对投资组合管理、绩效归因、基金估值、投资组合分析有一定基础，具有相关工作实习经验优先；'
            //     }, {
            //         name: '5、具备优秀的写作能力、文案管理能力及沟通协同能力；'
            //     }, {
            //         name: '6、有钻研精神和有责任心，对研究类工作有兴趣和热情；'
            //     }, {
            //         name: '7、CFA、FRM持证人优先考虑。'
            //     }]
            //   }, {
            //     title: '投教基地运营负责人',
            //     content: [{
            //         name: '1、 负责公司投教基地建设完成后的整体运营工作，完善运营团队，跟进省级、国家级投教基地的申请；'
            //     }, {
            //         name: '2、 负责投资者教育宣传、推介工作，包括举办投教大赛、组织投教推广活动等；'
            //     }, {
            //         name: '3、负责投资者教育基地线上官网、微信公众号等自媒体建立及运营工作；'
            //     }, {
            //         name: '4、负责智善联盟的活动组织及推广工作，将联盟与基地紧密协同；'
            //     }, {
            //         name: '5、 撰写原创文章，及时捕捉市场、行业热点事件，结合投教目标，策划投教选题；'
            //     }, {
            //         name: '6、参与公司品牌、宣传及自有媒体运营等工作；'
            //     }, {
            //         name: '7、协同配合公司办公室其他相关工作。'
            //     }],
            //     expects: [{
            //         name: '1、国内外知名院校，经济、金融等相关专业，本科及以上学历；'
            //     }, {
            //         name: '2、有5年以上投教相关工作经验；有省级、国家级投教基地建设、申报、运营经验者优先；'
            //     }, {
            //         name: '3、有投资者教育相关经验优先，有证券、期货、公募基金、私募基金相关行业实习经验优先'
            //     }, {
            //         name: '4、有CPA、CFA、FRM证书者优先；'
            //     }, {
            //         name: '5、能够熟练使用office、wind等软件；'
            //     }, {
            //         name: '6、具有较强的文字表达、沟通协调能力和团队合作能力，正直勤奋，细心负责，逻辑思维清晰，能够承受较强的工作压力。'
            //     }]
            //   }],
            positions: [{
                title: '市场高级经理（南京/上海）',
                content: [{
                    name: '1、根据公司募集规模要求，完成公司基金产品销售计划；'
                }, {
                    name: '2、拓展及维护机构客户、产业客户的合作渠道，达成产品销售规模业绩；'
                }, {
                    name: '3、有效输出公司投研理念和公司产品线布局，策划产品推广及品牌活动。'
                }],
                expects: [{
                    name: '1、经济、营销类相关专业，大学本科及以上学历；'
                }, {
                    name: '2、银行、信托、券商、公募、私募等从事机构财富管理业务岗位的成熟人才；'
                }, {
                    name: '3、具备较好的客户和渠道资源，能有效拓展市场规模，对客户需求能准确把握；'
                }, {
                    name: '4、对资管行业、资产配置、量化投资领域有一定了解与知识储备，熟悉资金募集流程，有3年以上基金募集经验；'
                }, {
                    name: '5、具有良好的沟通、协调能力、具有良好的团队协作精神和能力。'
                }]
              }, {
                title: '量化投资基金经理（南京/上海）',
                content: [{
                    name: '1、负责进行专项类别策略开发，包括但不限于CTA策略、高频策略、套利策略等；'
                }, {
                    name: '2、负责规模资金产品的实盘交易和管理，监控实盘策略，定期进行绩效分析；'
                }, {
                    name: '3、管理下属研究员进行进行策略研究，优化和改进策略模型；'
                }],
                expects: [{
                    name: '1、理工科或金融数学、金融工程背景；硕士博士优先、在校期间学科竞赛获奖者优先；'
                }, {
                    name: '2、三年以上投研经验，两年以上券商自营、公募、私募CTA或高频量化策略的实盘投资经验，业绩表现较好；'
                }, {
                    name: '3、具备极强的数理基础和编程能力（Python、C++、Sql等）；'
                }, {
                    name: '4、科研能力出色、认真细致、创新能力强、具有创业精神。'
                }]
              }, {
                title: '产品运营经理（南京）',
                content: [{
                    name: '1、调研和收集金融市场各类特色创新产品结构，定期与金融和托管机构沟通，主导完善公司的基金产品线规划；'
                }, {
                    name: '2、负责基金产品创设、产品备案、申赎管理、信息披露、分红清算等全生命周期的管理工作；'
                }, {
                    name: '3、负责客户和合作机构的管理和维护工作，根据客户需求提供定制化的产品服务；'
                }, {
                    name: '4、负责基金产品的数据统计和绩效分析，不断完善产品运营管理系统和客户管理系统；'
                }, {
                    name: '5、负责完成子基金的管理和维护工作，定期与投顾进行沟通回访，建立良好的合作关系。'
                }],
                expects: [{
                    name: '1、国内外知名院校，金融、经济、工商管理、法律等相关专业，硕士及以上学历；'
                }, {
                    name: '2、熟悉私募基金运营及私募行业新规，具备3年及以上基金、信托或相关金融行业相关工作经验；'
                }, {
                    name: '3、持有CFA、FRM证书优先；'
                }, {
                    name: '4、熟练使用 word 、 PPT 、 Excel、 Wind等办公软件，擅长数据处理分析，具备较强的文字协作能力；'
                }, {
                    name: '5、工作细致、耐心、效率高，有较强的协调、沟通能力及人际交往能力，具备较强的计划和执行能力；'
                }]
              }],  
            detailStatus: false,
            }
        },
        methods: {
            campusRecruitment(type) {
                this.currentType = type
                if (type === 1) {
                    this.campusRecruitmentStatus = true
                    this.listStatus = false
                    this.detailStatus = false
                    this.engageName = '社会招聘'
                } else if (type === 2) {
                    this.campusRecruitmentStatus = true
                    this.engageName = '实习招聘'
                    this.listStatus = false
                    this.detailStatus = false
                    // this.positions = [{
                    //     title: '量化开发助理(南京)',
                    //     content: [{
                    //         name: '1、协助进行策略系统和交易平台设计开发，负责量化交易实现系统稳定运行；'
                    //     }, {
                    //         name: '2、协助对接券商、期货公司等，配合做好系统接入流程；'
                    //     }, {
                    //         name: '3、交易系统、服务器运维与优化。'
                    //     }],
                    //     expects: [{
                    //         name: '1、金融工程、计算机、软件工程专业研究生或大四在读；'
                    //     }, {
                    //         name: '2、能够保证3个月以上实习，每周至少出勤4天；'
                    //     }, {
                    //         name: '3、熟练使用python、C++、C#；'
                    //     }, {
                    //         name: '4、对量化交易感兴趣，对国内交易规则有一定了解；'
                    //     }, {
                    //         name: '5、责任心强，细心稳重，善于沟通。'
                    //     }]
                    // }, {
                    //     title: '量化研究助理(南京、上海)',
                    //     content: [{
                    //         name: '1、负责中英文文献资料的阅读整理；'
                    //     }, {
                    //         name: '2、负责股票数据的收集和处理、数量化建模、历史数据回测等；'
                    //     }, {
                    //         name: '3、股票及大类资产因子的构建；'
                    //     }, {
                    //         name: '4、负责基金绩效的分析和评价研究；'
                    //     }, {
                    //         name: '5、协助研究员进行资产定价模型的开发和检验。'
                    //     }],
                    //     expects: [{
                    //         name: '1、金融工程、金融、数学、统计、计算机相关专业研究生在读或大四保研；'
                    //     }, {
                    //         name: '2、能够保证3个月以上实习，每周至少出勤4天；'
                    //     }, {
                    //         name: '3、能够熟练运用Python等统计分析语言，具有编程基础的优先；'
                    //     }, {
                    //         name: '4、具备较强的自学能力和严谨积极的工作态度，具有良好的沟通能力和团队合作精神；'
                    //     }, {
                    //         name: '5、具有金融工程或定量分析方面的实习经验、具有常用的定量模型与计算方法或量化实盘交易经验优先。'
                    //     }]
                    // }, {
                    //     title: '资产配置助理（固收方向）(南京、上海)',
                    //     content: [{
                    //         name: '1、协助更新维护日常业绩分析相关数据统计工作；'
                    //     }, {
                    //         name: '2、协助开展固收类资产定量和定性评价工作；'
                    //     }, {
                    //         name: '3、参与信用债相关专题研究和市场监控，跟踪信用风险成因和传导机制；'
                    //     }],
                    //     expects: [{
                    //         name: '1、大四保研或硕士在读，经济、金融等相关专业；'
                    //     }, {
                    //         name: '2、对信用债市场有基本的了解，有相关实习经历优先；'
                    //     }, {
                    //         name: '3、每周至少出勤4天；'
                    //     }, {
                    //         name: '4、掌握Python和SQL，能熟练进行数据处理；'
                    //     }, {
                    //         name: '5、做事细致认真、有责任感，有一定抗压能力，具有较强的自我驱动力和创新精神，沟通表达能力良好。'
                    //     }]
                    // }, {
                    //     title: '资产配置助理（量化方向）(上海)',
                    //     content: [{
                    //         name: '1、协助维护子基金业绩评价和筛选体系，协助与投顾进行尽调访谈并撰写分析报告；'
                    //     }, {
                    //         name: '2、协助参与投顾调研，以及核心投顾池、备选基金池的组建和维护；'
                    //     }, {
                    //         name: '3、数据系统维护以及交办的其他工作；'
                    //     }, {
                    //         name: '4、构建股票量化策略的市场监控模型，研究各类子基金的量化投资策略；'
                    //     }, {
                    //         name: '5、协助股票量化策略TAA择时体系研究，包括研报阅读、核心结论与算法复现；'
                    //     }, {
                    //         name: '6、协助股票量化管理人归因分析研究，包括研报阅读、核心结论与算法复现；'
                    //     }],
                    //     expects: [{
                    //         name: '1、金融、数理、统计、计算机等相关专业研究生在读或大四保研；'
                    //     }, {
                    //         name: '2、能够保证3个月以上实习，每周至少出勤4天；'
                    //     }, {
                    //         name: '3、掌握Python和SQL，具有较强的数据分析和编程能力；'
                    //     }, {
                    //         name: '4、了解国内金融市场及量化策略，对多因子投资、基金分析、绩效归因等有一定基础，具有相关工作实习经验优先；'
                    //     }, {
                    //         name: '5、做事细致认真、有责任感，具有较强的自我驱动力和创新精神，沟通表达能力良好，对研究类工作有兴趣和热情。'
                    //     }]
                    // }, {
                    //     title: '市场助理(南京)',
                    //     content: [{
                    //         name: '1、有效的贯彻执行公司市场拓展政策和流程；'
                    //     }, {
                    //         name: '2、协助市场经理进行业务拓展和客户关系维护；'
                    //     }, {
                    //         name: '3、负责制作公司各基金产品运作情况定期报告；'
                    //     }, {
                    //         name: '4、负责各类金融机构尽调文档的编制与汇总；'
                    //     }, {
                    //         name: '5、负责各类宣传材料的制作；'
                    //     }, {
                    //         name: '6、负责部门文档的建设与管理，为市场人员提供中台支持；'
                    //     }, {
                    //         name: '7、有效挖掘市场行业信息，并及时把相关信息汇总反馈给部门领导；'
                    //     }, {
                    //         name: '8、协助进行品牌推广。'
                    //     }],
                    //     expects: [{
                    //         name: '1、全日制金融、经济、法律等相关专业大四或研究生在读；'
                    //     }, {
                    //         name: '2、能够保证3个月以上实习，每周至少出勤4天；'
                    //     }, {
                    //         name: '3、对资管行业、资产配置、量化投资领域有一定了解与知识储备；'
                    //     }, {
                    //         name: '4、具有较强的ppt制作、数据处理方面的能力；'
                    //     }, {
                    //         name: '5、有较强的协调、沟通能力及人际交往能力，具备较强的计划和执行能力；'
                    //     }, {
                    //         name: '6、持有CFA、FRM证书优先；'
                    //     }, {
                    //         name: '7、良好的团队协作精神，做事细心负责、为人诚实可靠、品行端正。'
                    //     }]
                    // }, {
                    //     title: '品牌设计助理(南京)',
                    //     content: [{
                    //         name: '1、协助完成微信公众号、官网等线上媒体的日常运营及维护工作，包括公众号内容策划与编辑、新闻报道发布与编辑、版面规划与设计、品牌营销与推广等工作；'
                    //     }, {
                    //         name: '2、协助完成公司月刊、专刊、专题设计策划排版工作，每月定期配合完成指定策划项目文案设计、文字校正、版面规划等工作；'
                    //     }, {
                    //         name: '3、协助完成对接外部媒介，参与配合PR关系建立与维护，着重参与基金产品对外数据公布与评比申报、跟踪工作；'
                    //     }, {
                    //         name: '4、协助完成公司重大活动协调与保障工作，配合完成相关活动报道及新闻稿件撰写等工作。'
                    //     }],
                    //     expects: [{
                    //         name: '1、全日制新传、设计等相关专业研究生或大四在读；'
                    //     }, {
                    //         name: '2、能够保证3个月以上实习，每周至少出勤4天；'
                    //     }, {
                    //         name: '3、熟悉微信公众号运营方式，，具有较强的文字功底和文案撰写能力；'
                    //     }, {
                    //         name: '4、具备一定的美编功底，熟练使用PS、AI、平面设计等软件者优先；具有良好的计划、组织能力，拥有一定的大型活动组织经验。'
                    //     }]
                    // }, {
                    //     title: '风控合规助理(南京)',
                    //     content: [{
                    //         name: '1、配合处理公司日常的合规工作；'
                    //     }, {
                    //         name: '2、整理、分析私募基金行业最新监管政策、监管案例；'
                    //     }, {
                    //         name: '3、协助整理、编写公司合规月报；'
                    //     }, {
                    //         name: '4、配合搭建公司法治体系建设；'
                    //     }, {
                    //         name: '5、协助完成风控系统的搭建、测试及上线工作；'
                    //     }, {
                    //         name: '6、协助完成员工合规风控培训等相关工作。'
                    //     }],
                    //     expects: [{
                    //         name: '1、2023年及以后毕业，法律、金融、经济等相关专业；'
                    //     }, {
                    //         name: '2、熟练使用office办公软件；'
                    //     }, {
                    //         name: '3、有法律、金融相关行业实习经验优先考虑；'
                    //     }, {
                    //         name: '4、为人亲和，工作认真细致，责任心强，具有较强的沟通能力。'
                    //     }]
                    // }, {
                    //     title: '人力资源助理(南京)',
                    //     content: [{
                    //         name: '1、协助完成招聘工作安排、通知及现场实施；'
                    //     }, {
                    //         name: '2、协助执行培训方案的制定和培训现场实施、培训效果评估等全流程工作；'
                    //     }, {
                    //         name: '3、协助完成考勤统计及实习生薪资补贴发放；'
                    //     }, {
                    //         name: '4、协助进行人力资源档案的整理、记录、收集、存档和保管工作；'
                    //     }, {
                    //         name: '5、协助完成相关人力资源法律法规的收集与提醒。'
                    //     }],
                    //     expects: [{
                    //         name: '1、人力资源、工商管理、社会保障、经济管理相关专业研究生或大四在读；'
                    //     }, {
                    //         name: '2、能够保证3个月以上实习，每周至少出勤4天；'
                    //     }, {
                    //         name: '3、能够熟练使用office办公软件；'
                    //     }, {
                    //         name: '4、较强的沟通和组织能力，有过招聘或培训的实习经验优先；'
                    //     }, {
                    //         name: '5、较强的文字功底，有过活动策划、通讯稿撰写等相关工作经验；'
                    //     }, {
                    //         name: '6、为人亲和，反映敏捷、责任心强。'
                    //     }]
                    // }]
                    this.positions = [{
                        title: '数据开发实习生',
                        content: [{
                            name: '1、负责金融科技部日常文件的结构化处理及数据维护；'
                        }, {
                            name: '2、辅助数据开发工程师完成代码开发及文档编写'
                        }],
                        expects: [{
                            name: '1、全日制本科及以上，计算机、软件开发或金融工程相关专业，能够保证至少三个月且每周出勤不低于4天的线下实习；'
                        }, {
                            name: '2、熟悉MYSQL数据库，熟悉sql操作；'
                        }, {
                            name: '3、能够熟练编写python程序，具备python编码和调试能力，熟悉包括但不限于numpy,pandas等python三方包，熟悉正则表达式；'
                        }, {
                            name: '4、细致认真有责任心，具备良好的代码习惯。'
                        }]
                    }, {
                        title: '人力资源实习生',
                        content: [{
                            name: '1、协助完成招聘工作安排、通知及面试；'
                        }, {
                            name: '2、协助进行培训活动的准备和实施，做好培训调研和满意度评估；'
                        }, {
                            name: '3、协助完成考勤统计；'
                        }, {
                            name: '4、负责档案的整理、记录、收集、存档和保管工作；'
                        }, {
                            name: '5、协助完成相关人力资源法律法规的收集与提醒。'
                        }],
                        expects: [{
                            name: '1、2025年及以后毕业，经管相关专业，人力资源专业优先，本科及以上学历；'
                        }, {
                            name: '2、能够熟练使用office办公软件；'
                        }, {
                            name: '3、有活动组织策划经验优先；'
                        }, {
                            name: '4、为人亲和，反映敏捷、责任心强，具有较强的沟通能力。'
                        }]
                    }, {
                        title: '量化研究助理',
                        content: [{
                            name: '1、资产定价相关文献阅读与梳理；'
                        }, {
                            name: '2、股票及大类资产因子的构建；'
                        }, {
                            name: '3、协助研究员进行资产定价模型的开发和检验；'
                        }, {
                            name: '4、其他日常研究工作。'
                        }],
                        expects: [{
                            name: '1、可实习3月以上，每周保证4-5天到岗；'
                        }, {
                            name: '2、大四保研、研一优先，理工科院校数学、统计、金融工程、计量经济学专业优先；'
                        }, {
                            name: '3、利用python开展过研究工作，熟悉Wind等工具使用优先；'
                        }, {
                            name: '4、掌握Python和SQL，能熟练进行数据处理；'
                        }, {
                            name: '5、熟悉Excel、PowerPoint，有较好的可视化能力。'
                        }]
                    }, {
                        title: '资产配置实习生',
                        content: [{
                            name: '1、参与量化套利类资产研究，包括但不限于主交易品种跨期跨品种套利监控、套利策略复盘等；'
                        }, {
                            name: '2、协助更新维护日常业绩分析相关数据统计工作；'
                        }],
                        expects: [{
                            name: '1、大四保研或硕士在读，经济、金融等相关专业；'
                        }, {
                            name: '2、有相关金工实习经历优先；'
                        }, {
                            name: '3、每周至少出勤4天；'
                        }, {
                            name: '4、掌握Python和SQL，能熟练进行数据处理；'
                        }, {
                            name: '5、做事细致认真、有责任感，有一定抗压能力，具有较强的自我驱动力和创新精神，沟通表达能力良好。'
                        }]
                    }]
                } else {
                    this.campusRecruitmentStatus = true
                    this.engageName = '校园招聘'
                    this.listStatus = false
                    this.detailStatus = false
                    // this.positions = [{
                    //     title: '市场助理(南京)',
                    //     content: [{
                    //         name: '1、有效的贯彻执行公司市场拓展政策和流程；'
                    //     }, {
                    //         name: '2、协助市场经理进行业务拓展和客户关系维护；'
                    //     }, {
                    //         name: '3、负责制作公司各基金产品运作情况定期报告；'
                    //     }, {
                    //         name: '4、负责各类金融机构尽调文档的编制与汇总；'
                    //     }, {
                    //         name: '5、负责各类宣传材料的制作；'
                    //     }, {
                    //         name: '6、负责部门文档的建设与管理，为市场人员提供中台支持；'
                    //     }, {
                    //         name: '7、有效挖掘市场行业信息，并及时把相关信息汇总反馈给部门领导；'
                    //     }, {
                    //         name: '8、协助进行品牌推广。'
                    //     }],
                    //     expects: [{
                    //         name: '1、全日制金融、经济、法律等相关专业大四或研究生在读；'
                    //     }, {
                    //         name: '2、能够保证3个月以上实习，每周至少出勤4天；'
                    //     }, {
                    //         name: '3、对资管行业、资产配置、量化投资领域有一定了解与知识储备；'
                    //     }, {
                    //         name: '4、具有较强的ppt制作、数据处理方面的能力；'
                    //     }, {
                    //         name: '5、有较强的协调、沟通能力及人际交往能力，具备较强的计划和执行能力；'
                    //     }, {
                    //         name: '6、持有CFA、FRM证书优先；'
                    //     }, {
                    //         name: '7、良好的团队协作精神，做事细心负责、为人诚实可靠、品行端正。'
                    //     }]
                    // }, {
                    //     title: '市场助理(上海)',
                    //     content: [{
                    //         name: '1、有效的贯彻执行公司市场拓展政策和流程；'
                    //     }, {
                    //         name: '2、协助市场经理进行业务拓展和客户关系维护；'
                    //     }, {
                    //         name: '3、负责制作公司各基金产品运作情况定期报告；'
                    //     }, {
                    //         name: '4、负责各类金融机构尽调文档的编制与汇总；'
                    //     }, {
                    //         name: '5、负责各类宣传材料的制作；'
                    //     }, {
                    //         name: '6、负责部门文档的建设与管理，为市场人员提供中台支持；'
                    //     }, {
                    //         name: '7、有效挖掘市场行业信息，并及时把相关信息汇总反馈给部门领导；'
                    //     }, {
                    //         name: '8、协助进行品牌推广。'
                    //     }],
                    //     expects: [{
                    //         name: '1、全日制金融、经济、法律等相关专业大四或研究生在读；'
                    //     }, {
                    //         name: '2、能够保证3个月以上实习，每周至少出勤4天；'
                    //     }, {
                    //         name: '3、对资管行业、资产配置、量化投资领域有一定了解与知识储备；'
                    //     }, {
                    //         name: '4、具有较强的ppt制作、数据处理方面的能力；'
                    //     }, {
                    //         name: '5、有较强的协调、沟通能力及人际交往能力，具备较强的计划和执行能力；'
                    //     }, {
                    //         name: '6、持有CFA、FRM证书优先；'
                    //     }, {
                    //         name: '7、良好的团队协作精神，做事细心负责、为人诚实可靠、品行端正。'
                    //     }]
                    // }, {
                    //     title: '产品运营助理(南京)',
                    //     content: [{
                    //         name: '1、调研和收集金融市场各类特色创新产品结构，定期与金融和托管机构沟通，协助完善公司的基金产品线规划；'
                    //     }, {
                    //         name: '2、负责基金产品创设、产品备案、申赎管理、信息披露、分红清算等全生命周期的管理工作；'
                    //     }, {
                    //         name: '3、负责客户和合作机构的管理和维护工作，根据客户需求提供定制化的产品服务；'
                    //     }, {
                    //         name: '4、协助基金产品的数据统计和绩效分析，协助完善产品运营管理系统和客户管理系统；'
                    //     }, {
                    //         name: '5、协助完成基金相关的营销文案，组织策划市场推广及品牌活动；'
                    //     }, {
                    //         name: '6、协助完成子基金的管理和维护工作，定期与投顾进行沟通回访，建立良好的合作关系；'
                    //     }],
                    //     expects: [{
                    //         name: '1、国内外知名院校，金融、经济、工商管理、法律等相关专业，硕士及以上学历；'
                    //     }, {
                    //         name: '2、熟悉私募基金运营，有基金、信托或相关金融行业相关实习经验者优先；'
                    //     }, {
                    //         name: '3、持有CFA、FRM证书优先；'
                    //     }, {
                    //         name: '4、熟练使用 word 、 PPT 、 Excel、 Wind等办公软件，擅长数据处理分析，具备较强的文字协作能力；'
                    //     }, {
                    //         name: '5、工作细致、耐心、效率高，有较强的协调、沟通能力及人际交往能力，具备较强的计划和执行能力'
                    //     }]
                    // }]
                    this.positions = [{
                        title: '市场助理岗位（南京）',
                        content: [{
                            name: '1、有效的贯彻执行公司市场拓展政策和流程；'
                        }, {
                            name: '2、市场策划与设计市场方案工作；'
                        }, {
                            name: '3、协助市场经理进行业务拓展和客户关系维护；'
                        }, {
                            name: '4、负责各类金融机构尽调文档的编制与汇总；'
                        }, {
                            name: '5、有效挖掘市场信息，并及时把相关信息反馈给部门领导'
                        }],
                        expects: [{
                            name: '1、国内外院校，金融、经济、工商管理、市场营销等相关专业，硕士及以上学历；'
                        }, {
                            name: '2、对资管行业、资产配置、量化投资领域有一定了解与知识储备，熟悉资金募集流程，有基金募集经验优先；'
                        }, {
                            name: '3、能有效拓展市场规模，对客户需求能准确把握，具备较好的客户和渠道资源优先；'
                        }, {
                            name: '4、有较强的协调、沟通能力及人际交往能力，具备较强的计划和执行能力；'
                        }, {
                            name: '5、持有CFA、FRM证书优先；'
                        }, {
                            name: '6、良好的团队协作精神，为人诚实可靠、品行端正。'
                        }]
                    }, {
                        title: '基金产品运营岗位（南京）',
                        content: [{
                            name: '1、协助完成基金产品发行、备案过程中内外部沟通、相关文档资料制作与传递工作；'
                        }, {
                            name: '2、协助完成基金配置过程中相关材料的制作；'
                        }, {
                            name: '3、协助完成基金产品后期管理与运营，包括基金产品的信息披露、客户资料整理、申购赎回服务与清算等。'
                        }],
                        expects: [{
                            name: '1、全日制金融、经济、法律等相关专业本科及以上学历；'
                        }, {
                            name: '2、熟练使用Office办公软件，具有良好的数据处理能力；'
                        }, {
                            name: '3、掌握金融、基金基础知识，学习能力强，工作积极主动，踏实上进，处事细心。'
                        }]
                    }, {
                        title: '资产配置研究员（实习/校招）',
                        content: [{
                            name: '1. 协助基金经理构建和维护资产配置组合，参与组合绩效归因模型的开发和完善，并提供组合投资的配置和风控建议，定期生成产品运作报告；'
                        }, {
                            name: '2. 构建各量化策略的市场监控模型，研究各类子基金的量化投资策略，定期撰写资产配置月刊等品牌宣传材料；'
                        }, {
                            name: '3. 维护子基金业绩评价和筛选体系，定期与投顾进行尽调访谈并撰写分析报告；'
                        }, {
                            name: '4. 协助完成基金评价中心规划材料，推进基金评价项目，安排、处理基金评价中心日常事务；'
                        }, {
                            name: '5. 协助参与投顾调研，以及核心投顾池、备选基金池的组建和维护；'
                        }, {
                            name: '6. 数据系统维护以及领导交办的其他工作。'
                        }],
                        expects: [{
                            name: '1. 国内外知名院校，金融工程、数学等相关专业，硕士及以上学历；'
                        }, {
                            name: '2. 掌握主流编程语言，Python、Excel VBA等，具有较强的数据分析和编程能力，掌握主流数据库，如MySQL/MS SQL/Oracle等；'
                        }, {
                            name: '3. 了解国内金融市场及量化策略，对投资组合管理、绩效归因、基金估值、投资组合分析有一定基础，具有相关工作实习经验优先；'
                        }, {
                            name: '4. 具备优秀的写作能力、文案管理能力及沟通协同能力；'
                        }, {
                            name: '5. 有钻研精神和有责任心，对研究类工作有兴趣和热情；CFA、FRM持证人优先考虑。'
                        }]
                    }]
                }
            },
            handleDeatil(item) {
                this.currentDetail = item
                this.campusRecruitmentStatus = false
                this.listStatus = false
                this.detailStatus = true
            },
            goBack() {
                // this.$router.go(-1)
                this.campusRecruitmentStatus = true
                this.listStatus = false
                this.detailStatus = false
            },
            searchPosition() {
                alert(this.input)
            },
            onEnterNJ() {
                this.nanjing = true
            },
            onLeaveNJ() {
                this.nanjing = false
            },
            onEnterSH() {
                this.shanghai = true
            },
            onLeaveSH() {
                this.shanghai = false
            },
        },
        mounted() {
            this.timer = setInterval(() => {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                if (osTop === 0) {
                    clearInterval(this.timer)
                }
            }, 30)
        },
        computed: {

        },
    }
</script>
<style scoped>
.just_center {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
<style>
.engage_page .el-input__inner {
    height:50px;
    line-height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/hsEngage.vue